<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <Footer v-if="source != 'app'"></Footer>
    <div class="activity" v-if="flag && adlist.ad_images != '' && adlist.ad_images != null && adlist.ad_images != undefined && is">
      <div class="activitys">
        <div class="activity_img">
          <img :src="adlist.ad_images" @click="goActivity(adlist.ad_url)" />
        </div>
        <div class="close">
          <img src="./assets/close.png"  @click="close">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Footer from "@/components/footer";
  import { index_ad } from "./network/get.js";
  import cookie from "@/utils/store/cookie";
  export default {
    name: 'App',
    provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量
      return {
        reload: this.reload,
        source: 'h5'
      }
    },
    data() {
      return {
        isRouterAlive: true,
        flag:true,
        is:false,
        adlist:{}
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        })
      },
      close(){
        this.flag = false
      },
      goActivity(url=0){
        if(url == 0) return;
        window.location.href = url
      },
      get_ad(){
        index_ad().then(res => {
          this.adlist = res.data
        }).catch(err => {
          console.log(err)
        })
      }
    },
    mounted(){
      this.get_ad();
      this.source = cookie.get('source')
      if(window.location.hash == '#/'){
        this.is = true;
      }else{
        this.is = false;
      }
    },
    updated(){
      if(window.location.hash == '#/'){
        this.is = true;
      }else{
        this.is = false;
      }
    },
    components: {
      Footer
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }

  .van-swipe__indicator {
    background-color: #3361ED !important;
    height: 5px !important;
    width: 5px !important;
  }

  .van-swipe__indicator--active {
    height: 5px !important;
    width: 16px !important;
    border-radius: 4px !important;
  }

  .van-tabs__nav {
    background-color: #f7f8f9 !important;
  }

  .van-tabs__line {
    width: 25px !important;
    height: 4px !important;
  }

  .van-tab {
    font-size: 16px
  }

  .van-action-sheet__header {
    text-align: left !important;
    padding-left: 5%;
    font-weight: 600;
  }

  .van-action-sheet {
    padding-bottom: 60px;
  }
</style>
<style scoped>
  .activity{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.75);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    overflow-y: scroll;
  }
  .activitys{
    border: 0px solid red;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .activity_img{
    width: 293.46px;
    max-height: 450px;
    height: 100%;
    /* border: 1px solid red; */
    margin: 0 auto;
    overflow:hidden
  }
  .activity_img img{
    width: 293.46px;
    height: 100%;
  }
  .close{
    width: 27px;
    height: 27px;
    margin: 0 auto;
    margin-top: 11px;
  }
  .close img{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue